<script lang="ts">
    import { _ } from 'svelte-i18n';

    import ColumnSelectElement from './ColumnSelectElement.svelte';
    import Checkbox from '../Checkbox/Checkbox.svelte';
    import TemplateSection from './TemplateSection.svelte';
    import { SelectManager } from './SelectManager';
    import DualList from '../DualList.svelte';

    export let section: string;
    export let validateForm: () => void;
    export let title: string;

    export let sm: SelectManager;

    let items: any[] = [];

    function onCheckboxChange(id: string, selected: boolean, order: number|undefined) {
        sm.setCheckboxOption(id, selected, order);
    }

    $: {
        if (section == 'columnVisibility') {
            sm.getElementsFromSection(section).forEach((element) => {
                if (element.type === 'checkbox') {
                    let currentItem = items.filter((i) => i.id == element.id)[0] ?? null;
                    if (currentItem) {
                        let setAttributes: any = {disabled: !element.enabled};
                        if (!element.enabled) {
                            setAttributes.selected = element.checked;
                        }
                        currentItem = Object.assign(currentItem, setAttributes);
                    } else {
                        items.push({id: element.id, label: element.label, disabled: !element.enabled, selected: element.checked, order: element.order});
                    }
                }
            });
            items = items;
        }
    }

</script>

<TemplateSection>
    <div slot="section-title">{$_(title)}</div>
    <div
        slot="section-items"
        style="width: 100%; display:flex; flex-direction: column; row-gap: 5px;"
    >
        {#if section == 'columnVisibility'}
            <DualList bind:items sortable={true} onChange={onCheckboxChange}/>
        {:else}
            {#each sm.getElementsFromSection(section) as element, index (element.id)}
                {#if element.type === 'checkbox'}
                    <div class="checkbox-container" data-disabled={element?.enabled ? 'false' : 'true'}>
                        <Checkbox
                            label={element.label}
                            checked={element.checked}
                            disabled={!element.enabled}
                            onChange={() => {
                                if (element.type === 'checkbox') {
                                    element.checked = !element.checked;
                                } else {
                                    throw new Error('Element type is not checkbox: ' + element.label);
                                }
                            }}
                        />
                    </div>
                {:else}
                    <ColumnSelectElement {element} {validateForm} bind:sm />
                {/if}
            {/each}
        {/if}
    </div>
</TemplateSection>

<style>
    .checkbox-container {
        margin-left: 60px;
    }
</style>
